module.exports = __webpack_public_path__ + "img/album07_31.ae3f9824.jpg";